import {Config} from './config'

angular.module('app')
  .config(["$windowProvider", "$routeProvider", "$locationProvider", "toastrConfig", "ngMetaProvider",
    ($windowProvider, $routeProvider, $locationProvider, toastrConfig, $window, ngMetaProvider) => new Config($windowProvider, $routeProvider, $locationProvider, toastrConfig, $window, ngMetaProvider)]);
